import { Typography } from '@mui/material'
import React from 'react'

function Status({ text, color, bg }) {
    const cellStyle = {
        //styleName: Type/Android/16 Regular;
        // fontFamily: 'HelveticaNeue',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '24px',
        letterSpacing: '0em',
        textAlign: 'left',
        color: color, 
        textTransform:'capitalize'

    }
    return (
        <>
            <Typography
                className={`text-center rounded !text-[${color}] px-3 py-1 w-[fit-content]`}
                sx={{ ...cellStyle, bgcolor: bg,  }}>{text}
                {/* {text[0].toUpperCase() + text.substring(1, text.length)} */}
            </Typography>

        </>
    )
}

export default Status